import { http } from '../../config/axios'

const graficoConsulta = (idFranquia: string): Promise<any> => {
  
  return http
    .get('api/consulta/grafico/'+idFranquia)
    .then((res) => {
      return res.data as any
    })
    .catch((error) => {
      console.error('Erro graficoConsulta', error)
      throw Error(error.response.data)
    })
}

export default graficoConsulta;
